<script>
import { MessageBox } from "element-ui";

export default {
  name: "AccountExit",
  methods: {
    handleLogOut() {
      MessageBox.confirm("确定要退出登录吗？", "提示", { type: "warning" })
        .then(() => {
          this.$store
            .dispatch("logout")
            // .then(() => this.$router.push("/homes/home"));
            window.location.reload();
        })
        .catch(() => {});
    },
  },
};
</script>

<template>
  <div class="account-exit" @click.stop="handleLogOut">
    <img style="width: 27px;height: 27px;" src="@/assets/images/onlogin-icon.png" alt="">
  </div>
</template>

<style lang="scss" scoped>
.account-exit {
  width: 24px;
  height: 24px;
  color: rgba(48, 48, 48, 0.68);
  transition: color 0.1s;
  cursor: pointer;

  &:hover {
    color: #ff1200;
  }
}
</style>
